/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiUserUserType
 */
export interface ApiUserUserType {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    title?: string;
    /**
     * 
     */
    type?: string;
    /**
     * 
     */
    description?: string;
}

/**
 * Check if a given object implements the ApiUserUserType interface.
 */
export function instanceOfApiUserUserType(value: object): value is ApiUserUserType {
    return true;
}

export function ApiUserUserTypeFromJSON(json: any): ApiUserUserType {
    return ApiUserUserTypeFromJSONTyped(json, false);
}

export function ApiUserUserTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiUserUserType {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'type': json['type'] == null ? undefined : json['type'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function ApiUserUserTypeToJSON(json: any): ApiUserUserType {
    return ApiUserUserTypeToJSONTyped(json, false);
}

export function ApiUserUserTypeToJSONTyped(value?: ApiUserUserType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'type': value['type'],
        'description': value['description'],
    };
}

